import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/volunteer-2.webp'


const _withScopeId = n => (_pushScopeId("data-v-057b98fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "first scroll-to" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "VOLUNTEER WITH US")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, " Our organization is based on volunteers willing to love on the neighbour. "),
  /*#__PURE__*/_createElementVNode("span", null, " We send teams of volunteers for short trips to Colombia to help through workshops, teaching, construction work, medical practices, food distribution and simply giving hope and valuable tools to the rural population of Colombia. "),
  /*#__PURE__*/_createElementVNode("span", null, " We welcome anyone with a heart for the people, don't hesitate to connect with us to find out more or to sign up as a volunteer! ")
], -1))
const _hoisted_4 = { class: "second scroll-to" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "UNLOCKING POTENTIAL", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Our team will be imparting different classes to the women and children of Palenque. These workshops are designed to empower these people to step into the fullness of their potential by receiving fresh knowledge and practical tools that will push them to greater opportunities."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, " We believe the work of our volunteers will empower the people of Palenque to have greater opportunities, whether it is when searching for a job or choosing to take a leap of faith and stepping into the world of entrepreneurship; we believe in the innate power within every individual, and our mission is to empower them to recognize and unleash their true potential! "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "Explore our on-site projects and discover how you can make a meaningful impact as a volunteer with us!")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_lp_sticky_button = _resolveComponent("lp-sticky-button")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("section", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("article", null, [
        _hoisted_3,
        _createVNode(_component_router_link, {
          to: "/contact",
          custom: ""
        }, {
          default: _withCtx(({ navigate }) => [
            _createVNode(_component_lp_button, {
              onClick: navigate,
              size: "large",
              type: "outlined",
              color: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode("CONTACT US ")
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("section", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("article", null, [
        _hoisted_6,
        _createElementVNode("div", null, [
          _hoisted_7,
          _createVNode(_component_router_link, {
            to: "/projects",
            custom: ""
          }, {
            default: _withCtx(({ navigate }) => [
              _createVNode(_component_lp_button, {
                onClick: navigate,
                size: "large",
                type: "outlined",
                color: "primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("OUR PROJECTS ")
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(_component_lp_sticky_button)
  ]))
}